module.exports = __webpack_public_path__ + "img/ocb_web.e24d6ef4.png";